<template>
  <el-dialog
    :visible.sync="visible"
    title="⚠️ COMUNICADO IMPORTANTE – NOVO PRAZO"
    width="520px"
    custom-class="monitriip-notice"
    append-to-body
    @close="persistDismissal"
  >
    <p>
      Informamos que o prazo para adequação ao sistema monitriip foi prorrogado para
      <strong>15/02/2027</strong>.
    </p>
    <p>Reforçamos que os seguintes procedimentos são obrigatórios:</p>
    <ul>
      <li>Geração do Token de Produção;</li>
      <li>Envio do Token de Produção para a Nogartel.</li>
    </ul>
    <p>
      Solicitamos que todas as providências sejam realizadas dentro do novo prazo
      estabelecido, a fim de garantir a regularidade do processo.
    </p>
    <span slot="footer">
      <el-button type="primary" @click="visible = false">Entendi</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

// Notice requested by ANTT/MONITRIIP compliance (deadline 15/02/2027). It is shown
// only to accounts that have at least one device with the 'monitrip' integration
// (Option A targeting), once per browser, and only until the deadline passes.
// After 15/02/2027 the whole component can be removed.
const STORAGE_KEY = 'monitriipEndpointsNotice-2027-02-15'
const DEADLINE = new Date('2027-02-16T00:00:00-03:00') // stop showing once 15/02/2027 (BRT) is over

export default {
  name: 'MonitriipNotice',
  data() {
    return {
      visible: false
    }
  },
  computed: {
    ...mapGetters(['devices', 'devicesLoaded']),
    isMonitriipCustomer() {
      return this.devices.some(
        d => d.attributes && typeof d.attributes.integration === 'string' &&
          d.attributes.integration.includes('monitrip')
      )
    }
  },
  watch: {
    devicesLoaded: {
      immediate: true,
      handler() {
        this.maybeShow()
      }
    }
  },
  methods: {
    maybeShow() {
      if (!this.devicesLoaded || this.visible) return
      if (Date.now() >= DEADLINE.getTime()) return
      if (!this.isMonitriipCustomer) return
      if (this.alreadyDismissed()) return
      this.visible = true
    },
    alreadyDismissed() {
      try {
        return window.localStorage.getItem(STORAGE_KEY) === '1'
      } catch (e) {
        return false
      }
    },
    persistDismissal() {
      try {
        window.localStorage.setItem(STORAGE_KEY, '1')
      } catch (e) {
        // ignore storage errors (private mode, etc.)
      }
    }
  }
}
</script>

<style>
.monitriip-notice.el-dialog {
  max-width: calc(100vw - 24px);
}
.monitriip-notice .el-dialog__body {
  line-height: 1.6;
}
.monitriip-notice .el-dialog__body p,
.monitriip-notice .el-dialog__body ul {
  margin: 0 0 12px;
}
.monitriip-notice .el-dialog__body ul {
  padding-left: 20px;
}
.monitriip-notice .el-dialog__body li + li {
  margin-top: 4px;
}
</style>
